import { useEffect, useState } from 'react'
// import { roleColumns } from './_columns'
import { roleColumns } from './_columnsC'
import { useQuery } from 'react-query'
import { KTCard } from '../../../../../../_metronic/helpers'
import { initialQueryState } from '../../../../../../_metronic/helpers'
import { getUserById } from '../../../data-administration/data-admininstration-list/core/_requests'
import {
  QueryRequestProvider,
  useQueryRequest,
} from '../../../data-administration/data-admininstration-list/core/QueryRequestProvider'
import { QueryResponseProvider } from '../../../data-administration/data-admininstration-list/core/QueryResponseProvider'
import { ListViewProvider } from '../../../data-administration/data-admininstration-list/core/ListViewProvider'
import { UserEditModal } from '../../../data-administration/data-admininstration-list/form-edit-modal/CoomonEditModal'
import { UsersListHeader } from '../../../data-administration/data-admininstration-list/components/header/UsersListHeader'
import { UsersTable } from '../../../data-administration/data-admininstration-list/table/UsersTable'
import { setCategoriesData } from './categoryHelper';
const UsersList = () => {
  const { data } = useQuery(
    `clients/101212/categories`,
    () => getUserById('', 'clients/101212/categories'),
    {
      cacheTime: 0,
      onError: (err) => {
        console.warn(err)
      },
    }
  )
  const { updateState } = useQueryRequest()
  const [categoriesList, setCategoriesList] = useState([{ label: 'Select one', value: '' }])

  // ADD THIS FUNCTION:
  const handleCategoryChange = (selectedValue: string) => {
    updateState({
      enabled: true,
      initialApi: `categories/${selectedValue}/items`, // Force correct endpoint
      ...initialQueryState,
    })
  }


  useEffect(() => {
    if (data && data.length) {
      const dropdownData = data.map((eachData: any) => ({
        label: eachData.name,
        value: eachData.id
      }))

      setCategoriesList(dropdownData)
      setCategoriesData(dropdownData); // Set the categories data

      updateState({
        enabled: true,
        initialApi: `categories/${dropdownData[0].value}/items`,
        ...initialQueryState,
      })
    }
  }, [data])

  useEffect(() => {
    if (data && data.length) {
      let dropdownData: any = []
      data.map((eachData) => {
        return dropdownData.push({ label: eachData.name, value: eachData.id })
      })
      setCategoriesList(dropdownData)
      updateState({
        enabled: true,
        initialApi: `categories/${dropdownData[0].value}/items`,
        ...initialQueryState,
      })
    }
  }, [data])

  const searchElements = [
    {
      type: 'select',
      value: 'select',
      options: categoriesList,
      onChange: handleCategoryChange, // ADD THIS LINE
    },
  ]

  return (
    <KTCard>
      <p style={{
        fontSize: "14px", fontWeight: "bold", marginBottom: "-20px", marginLeft: "31px",
        marginTop: "15px",
      }}>Select category</p>
      <UsersListHeader
        searchElements={searchElements}
        placeholder='Search Category'
        label='Add new'
      />
      <UsersTable columnProps={roleColumns} />
      <UserEditModal arrayDropdown={categoriesList} formName='SubCategoryModalForm' />
    </KTCard>
  )
}

const FeedStockWrapper = () => (
  <QueryRequestProvider initialValue={{ enabled: false }}>
    <QueryResponseProvider>
      <ListViewProvider>
        <UsersList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export { FeedStockWrapper }